import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 20px;
`;

export const Balloon = styled.div`
  display: flex;
  align-items: center;
  background-color: #2293e9;
  padding: 16px;
  border-radius: 8px 8px 0 8px;
  color: white;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  margin-bottom: 6px;

  @media screen and (max-width: 414px) {
    padding: 8px 16px;
  }
`;

export const Time = styled.span`
  font-size: 12px;
  color: #818892;
`;
